<template>
  <div class="modal" tabindex="-1" id="contactFormModal">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <form v-on:submit="saveContactInfo">
          <div class="modal-body">
            <lord-icon src="https://cdn.lordicon.com/zpxybbhl.json" trigger="loop" delay="1000"
              colors="primary:#121331;secondary:#0180D8;" style="width:100px;height:100px;"></lord-icon>
            <h3>{{ $t('landingContact.heading') }}</h3>
            <p>{{ $t('landingContact.description') }}</p>
            <div class="mb-1'">
              <v-text-field id="fullNameInput" v-model="contactInfo.full_name"
                v-bind:label="$t('landingContact.fullName')"></v-text-field>
            </div>
            <div class="mb-1">
              <v-text-field v-model="contactInfo.email" type="email" v-bind:label="$t('Email')"></v-text-field>
            </div>
            <div class="mb-1">
              <vue-tel-input-vuetify id="phoneNumberInput" v-on:input="updatePhoneNumber"
                v-bind:error-messages="phoneErrors" name="phone_number" v-bind:label="$t('phone_number')"
                v-bind:placeholder="$t('landingContact.phonePlaceholder')"></vue-tel-input-vuetify>
            </div>
            <div class="mb-1">
              <v-textarea v-model="contactInfo.comment" v-bind:label="$t('landingContact.comment')" auto-grow
              rows="1"></v-textarea>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{
              $t('Close') }}</button>
            <button type="submit" class="btn btn-primary">{{ $t('Confirm') }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import GlobalMixin from '@/GlobalMixin.js';
export default {
  mixins: [GlobalMixin],
  data: () => ({
    contactInfo: {
      full_name: null,
      email: null,
      phone_number: null,
      status: false
    },
    phoneErrors: [],
    phoneValid: false
  }),
  mounted() {

  },
  methods: {
    saveContactInfo(e) {
      e.preventDefault();
      console.log('contact info', this.contactInfo);
      if (this.phoneValid) {
        this.phoneErrors = [];
        this.axios.post(`${process.env.VUE_APP_APIEndPoint}auth/contact_us/`, this.contactInfo,
          this.headers).then((res) => {
            sessionStorage.setItem('landing-contact', true);
            $('#contactFormModal').modal('hide');
            Swal.fire({
              icon:'success',
              text: this.$t('landingContact.success')
            });
          }).catch(error => {
            let errors = '';
            error?.response?.data?.errors?.forEach((value, index) => {
              for(error in value){
                errors += `<li>${value[error]}</li>`;
              }
            });
            Swal.fire({
              icon: 'error',
              html: errors === ''? 'We had an issue processing your request please try again later' : errors 
            });
          });
      } else {
        this.phoneErrors = ['Phone number format is invalid']
      }
    },
    updatePhoneNumber(formattedNumber, { number, valid, country }) {
      if (valid) {
        this.phoneValid = true;
        this.contactInfo.phone_number = number.e164;
      } else {
        this.phoneValid = false;
      }
    },
    saveInterest() {
      sessionStorage.setItem('landing-contact', true);
    }
  },
}
</script>
<style scoped lang="scss">
#contactFormModal {
  .modal-body {
    text-align: center;
  }

  .modal-footer {
    .btn-primary {
      background-color: var(--auth-main-color);
      border-color: var(--auth-main-color);
      color: white;

      &:hover {
        background-color: var(--auth-main-color-hover);
        border-color: var(--auth-main-color-hover);
      }
    }
  }
}
</style>